import { render, staticRenderFns } from "./shipment-bill-detail.vue?vue&type=template&id=61643d9e&scoped=true&"
import script from "./shipment-bill-detail.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-detail.vue?vue&type=script&lang=js&"
import style0 from "./shipment-bill-detail.vue?vue&type=style&index=0&id=61643d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61643d9e",
  null
  
)

export default component.exports